import { createStore, combineReducers } from 'redux'
import {userSlice} from "./UserSlice";
import {metaSlice} from "./MetaSlice";

const appReducer = combineReducers({
    user: userSlice.reducer,
    meta: metaSlice.reducer
});

export const AppStore = createStore(appReducer);

export type AppState = ReturnType<typeof appReducer>;
